export default function dropzoneBaseConfig({ authToken }) {
  return {
    url: `${process.env.VUE_APP_API_URL}/image/`,
    previewTemplate: `<div class="d-none" />`,
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  };
}
